import { REFRESH_TOKEN_KEY, TOKEN_SESSION_KEY } from '../constants/commonConstants';
import { EP_CHANGE_USERNAME, EP_LOGIN, EP_REFRESH_TOKEN, EP_RESET_PSSSOWRD, EP_TOGGLE_ACCOUNT_ACTIVATE } from '../constants/endpointConstants';
import api from './Api';
import { customStorage } from './UtilityService';

const doLogin = async (email, password) => {
    const response = await api.post(EP_LOGIN, { email, password });
    return response.data;
};

const doRefreshToken = async () => {
    const accessToken = customStorage.getItem(TOKEN_SESSION_KEY);
    const refreshToken = customStorage.getItem(REFRESH_TOKEN_KEY);
    if (!accessToken || !refreshToken) {
        customStorage.clear();
        return null;
    }
    
    const response = await api.post(EP_REFRESH_TOKEN, { accessToken, refreshToken });
    return response.data;
};

const changeUsername = async (userId, username, password) => {
    const response = await api.post(EP_CHANGE_USERNAME, { userId, username, password });
    return response.data;
};

const resetPassword = async (requestData) => {
    const response = await api.post(EP_RESET_PSSSOWRD, requestData);
    return response.data;
};

const toggleAccountActivate = async (requestData) => {
    const response = await api.post(EP_TOGGLE_ACCOUNT_ACTIVATE, requestData);
    return response.data;
};

export { doLogin, doRefreshToken, changeUsername, resetPassword, toggleAccountActivate }